import { List } from '@/components/List';
import { LabradorComponent } from '@/types/component';

export const LabradorList: LabradorComponent = ({ data }) => {
  return <List items={data.items} as={data.tag} />;
};
